import React from 'react';
import { Route } from 'react-router-dom';
import { AREA_CAPABILITIES } from '../areaCapabilities';
import { TenderLedgerPage, TenderListPage, TenderRoomPage } from '../lazyComponents';

/**
 * Tender Management — confidential pre-project bid workspaces.
 *
 * `tender.read` only opens the module; which spaces a user actually sees is
 * decided per tender by the server-side ACL, so these routes stay coarse.
 */
export function TenderRoutes({ withCapability }) {
  return (
    <>
      <Route path="/tenders" element={withCapability(AREA_CAPABILITIES.tender, <TenderListPage />)} />
      <Route
        path="/tenders/archive"
        element={withCapability(AREA_CAPABILITIES.tender, <TenderListPage archived />)}
      />
      <Route path="/tenders/:tenderId" element={withCapability(AREA_CAPABILITIES.tender, <TenderRoomPage />)} />
      {/* Not a menu entry: reached from the room. The catalog stays at two
          routes so the capability prefix rule keeps meaning what it says. */}
      <Route
        path="/tenders/:tenderId/ledger"
        element={withCapability(AREA_CAPABILITIES.tender, <TenderLedgerPage />)}
      />
    </>
  );
}
